export default {
  banner: {
    title: "Zero-Trust IDaaS Solution",
    subtitle:
      "Authing provides a zero-trust IDaaS solution that combines cloud computing with IAM. It offers efficient and flexible unified identity authentication and governance functions for enterprises.",
  },
  advantage: {
    title: "Pros and Cons of Zero Trust IAM",
    subtitle:
      "IAM is key to Zero Trust and its core technologies include authentication, access control, identity governance, and privileged identity management, which enhances security and minimizes risks. However, traditional IAM has these limitations:",
    item1: {
      title: "Poor security",
      subtitle:
        "Traditional IAM is difficult to ensure security in a hybrid cloud environment.",
    },
    item2: {
      title: "Difficult to update",
      subtitle: "Traditional IAM requires huge manpower and time to update.",
    },
    item3: {
      title: "Costly maintenance",
      subtitle:
        "IAM needs to be self-hosted, and the cost of hiring or training IT experts is high.",
    },
    item4: {
      title: "Lack of scalability",
      subtitle:
        "As users increase, IAM's reliance on server stacking and load balancing becomes inefficient.",
    },
  },
  idaas: {
    title: "Build a more secure identity system with IDaaS",
    subtitle1:
      "Authing IDaaS provides flexible identity authentication and management services based on a cloud-native structure, solving the security and efficiency issues of traditional IAM and eliminating the need for enterprises to maintain servers themselves.",
    subtitle2: "",
    item1: {
      title: "Unified identity authentication",
      subtitle:
        "Authing supports protocols such as OIDC, OAuth2.0, SAML, LDAP, and third-party identity sources such as DingTalk, WeCom, and Feishu, helping enterprises to unify multiple identity sources flexibly and quickly.",
    },
    item2: {
      title: "Single Sign-On (SSO)",
      subtitle:
        "Authing integrates with 2000+ global applications, allowing businesses to easily connect multiple systems without significant development costs. We also offer SSO solutions for applications that do not support standard authentication protocols.",
    },
    item3: {
      title: "Adaptive MFA",
      subtitle:
        "Authing offers various authentication methods, including OTP, SMS, email, etc, and supports policy configuration to achieve dynamic and adaptive authentication by judging environmental risks such as IP, device, and behavior analysis.",
    },
    item4: {
      title: "Access Management",
      subtitle:
        "Authing supports permission models like RBAC and ABAC. Enterprises can create permission spaces through back-end operations, set authorization rules for resources such as data, menus, and APIs, and achieve fine-grained access management.",
    },
    item5: {
      title: "Lifecycle management",
      subtitle:
        "Authing's automated account management solution minimizes human error, avoiding the risks of misassigned accounts and untimely account termination, which reduces information leakage and ensures enterprise security and compliance.",
    },
    item6: {
      title: "Automated identity orchestration",
      subtitle: `Authing's "automated identity management" tool with nearly 80 pre-built templates allows enterprises to customize data and business processes based on their needs, improving identity management efficiency.`,
    },
  },
  security: {
    title: "Choose Authing to strengthen identity security",
    detail: "Learn more",
    "content-title":
      "Authing enables banks to create a more secure ZTA risk control center",
    "descript-list1":
      "Unified identity authentication and SSO for 1000+ internal bank applications, streamlining management and boosting efficiency.",
    "descript-list2":
      "Improve management of departments, user groups, and user access, reducing the risk of information leakage from cross-permission.",
    "descript-list3": ` Achieve identity management capabilities for "pre-event defense," "during-event monitoring," and "post-event audit."`,
    extra: "——From a large commercial bank",
  },
  compliance: {
    title: "Compliance and Safety Come First",
    subtitle:
      "We comply with requirements of different countries and industries, and actively participate in the  promotion of safety standards.",
    img1: "zero-trust-en-compliance1.png",
    img2: "zero-trust-en-compliance2.png",
    img3: "zero-trust-en-compliance3.png",
    img4: "zero-trust-en-compliance4.png",
    "descript-list1": "We use AES-256 encryption for storage",
    "descript-list2": "SSL/TLS with 2048-bit RSA keys for transmission",
    "descript-list3":
      "Our keys are managed by KMS, regularly rotated and used only once for high-security",
  },
};
